<template>
  <div>
    <div>
      <div class="d-flex align-items-center">
        <div>
          <h1 class="page-title">
            <a-icon type="arrow-left" @click="goBack" />
            {{ isEdit ? $t('promotion.edit_promotion') : $t('promotion.add_promotion') }}
          </h1>
        </div>
      </div>
    </div>
    <a-spin :spinning="isLoading || loadingFetchPromotionChannelDetail" :tip="getTipSpinningByState()">
      <a-form-model
        ref="createPromotionForm"
        :model="form"
        :rules="rulesCreatePromotion"
        :class="{ info: isDetail }"
      >
        <a-card :title="$t('promotion.promotion_info')" class="w-100 mt-4" :bordered="false" :body-style="{ paddingTop: '0' }">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('promotion.promotion_code')" prop="promoCode">
                <a-input
                  v-model.trim="form.promoCode"
                  size="large"
                  autocomplete="off"
                  :placeholder="$t('promotion.placeholder_promotion_code')"
                  allow-clear
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('promotion.start_date')" prop="startDate">
                <span @click.prevent="openStartDatePicker = true">
                  <a-date-picker
                    v-model="form.startDate"
                    size="large"
                    class="w-100"
                    :disabled="rawStatusPromotion.toLowerCase() === 'ongoing'"
                    :disabled-date="disabledDateBeforeCurrentDate"
                    :show-time="{ format: 'HH:mm' }"
                    :format="dateFormat"
                    :show-today="false"
                    locale="id-ID"
                    :open="openStartDatePicker"
                    :placeholder="$t('promotion.placeholder_start_date')"
                    @ok="handleChangePromotionDate($event, 'mulai')"
                    @change="undefined"
                  />
                </span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('promotion.end_date')" prop="endDate">
                <span @click.prevent="openEndDatePicker = true">
                  <a-date-picker
                    v-model="form.endDate"
                    size="large"
                    class="w-100"
                    :disabled-date="disabledDateBeforeSelectedStartDate"
                    :show-time="{ format: 'HH:mm' }"
                    :format="dateFormat"
                    :show-today="false"
                    :open="openEndDatePicker"
                    :placeholder="$t('promotion.placeholder_end_date')"
                    @ok="handleChangePromotionDate($event, 'berakhir')"
                  />
                </span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-card>

        <!-- Detail Item Produk -->
        <a-card :title="$t('promotion.product_info')" class="w-100 mt-4" :bordered="false" :body-style="{ paddingTop: '0' }">
          <template #extra>
            <div class="d-flex align-items-center justify-content-between mb-3">
              <div class="d-flex">
                <a-button
                  type="primary"
                  :disabled="!form.startDate || !form.endDate"
                  @click="addItem"
                >
                  {{ $t('promotion.add_item') }}
                </a-button>
                <a-button
                  class="ml-2"
                  type="primary"
                  :disabled="!form.startDate || !form.endDate"
                  @click="showModalBulkItemImport = true"
                >
                  {{ $t('promotion.bulk_import') }}
                </a-button>
              </div>
              <!-- <div>Total SKU: <b>{{ computedValidSKU || 0 }}</b></div> -->
            </div>
          </template>
          <a-collapse class="mb-4">
            <a-collapse-panel key="1">
              <template #header>
                <div style="font-weight: bold;">
                  {{ $t('promotion.batch_edit') }}
                </div>
                <div class="mb-2" style="font-size: 12px; color: gray;" v-html="$t('promotion.batch_edit_desc')" />
              </template>
              <a-row :gutter="24" class="mb-4" type="flex" align="top">
                <a-col :span="7">
                  <a-form-model-item :label="$t('promotion.discount_nominal')" prop="allDiscountNominal" class="mb-0">
                    <a-input
                      v-model.trim="form.allDiscountNominal"
                      :disabled="disabledFormAppliedAllDiscount"
                      autocomplete="off"
                      :placeholder="$t('promotion.placeholder_discount_nominal')"
                      allow-clear
                      addon-before="Rp"
                      @input="validateNumberInput($event, 'allDiscountNominal')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="7">
                  <a-form-model-item :label="$t('promotion.discount_percentage')" prop="allDiscountPercentage" class="mb-0">
                    <a-input
                      v-model.trim="form.allDiscountPercentage"
                      :disabled="disabledFormAppliedAllDiscount"
                      autocomplete="off"
                      :placeholder="$t('promotion.placeholder_discount_percentage')"
                      allow-clear
                      addon-after="%"
                      @input="validateNumberInput($event, 'allDiscountPercentage')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="5" offset="5">
                  <a-button
                    style="width: 100%"
                    type="secondary"
                    icon="plus"
                    :disabled="disabledFormAppliedAllDiscount || disabledCheckBothDiscount"
                    @click="handleChangeAppliedAllDiscount"
                  >
                    {{ $t('promotion.apply_all') }}
                  </a-button>
                </a-col>
              </a-row>
            </a-collapse-panel>
          </a-collapse>

          <a-spin :indicator="customIndicatorMandatoryDateRange" :spinning="!form.startDate || !form.endDate">
            <a-row :gutter="24">
              <a-col :span="24">
                <div>
                  <a-table
                    :columns="columns"
                    :row-key="(record, index) => index"
                    :data-source="itemList"
                    :loading="isLoading"
                    :pagination="false"
                    :scroll="{ y: 330, x: 1300 }"
                  >
                    <template slot="action1" slot-scope="text, record">
                      <div
                        @click="onDeleteItem(record)"
                      >
                        <TrashIcon style="color: #E00000; cursor:pointer" />
                      </div>
                    </template>
                    <template slot="selected_catalog_id" slot-scope="text, record">
                      <a-select
                        v-model="record.selected_catalog_id"
                        size="large"
                        class="select-antd-default"
                        style="width: 100%"
                        :placeholder="$t('promotion.product')"
                        show-search
                        :label-in-value="false"
                        :not-found-content="loadingFetchProductChannelList ? undefined : null"
                        :filter-option="false"
                        @change="handleChangeProduct($event, record)"
                        @popupScroll="handleScrollProductChannelList"
                        @focus="handleFocusProductChannelList"
                      >
                        <a-select-option
                          v-for="item in productChannelList"
                          :key="`${item.channel_product_id}.${item.channel_catalog_id}.${item.productTitle}`"
                          :value="`${item.channel_product_id}.${item.channel_catalog_id}`"
                          :disabled="!item.isEligible || selectedSKU.includes(item.sku) || item.currentStock === 0"
                        >
                          <a-spin
                            :spinning="!item.isEligible || item.currentStock === 0"
                          >
                            <template #indicator>
                              <div class="w-100" style="left: 0; margin: 0;">
                                <div v-if="!item.isEligible" class="w-100" style="margin-inline: auto; font-size: 10px;">
                                  {{ $t('promotion.not_eligible_date') }}
                                </div>
                                <div v-if="item.currentStock === 0" class="w-100" style="margin-inline: auto; font-size: 10px;">
                                  {{ $t('promotion.no_stock') }}
                                </div>
                              </div>
                            </template>
                            <div class="d-flex flex-column product-select">
                              <div>{{ item?.title }}</div>
                              <div class="sku-desc">
                                {{ 'SKU : ' + ellipsisText(item?.sku) }}
                              </div>
                            </div>
                          </a-spin>
                        </a-select-option>
                        <a-select-option 
                          v-if="!productChannelHasMoreData && productChannelList.length > 0"
                          key="endlist"
                          disabled
                          class="end-of-list-message"
                        >
                          <div class="d-flex justify-content-center align-items-center py-2" style="color: var(--kit-color-primary);">
                            {{ $t('promotion.all_products_shown') }}
                          </div>
                        </a-select-option>
                        <a-select-option 
                          v-if="loadingFetchProductChannelList"
                          key="loading"
                          disabled
                          class="infinite-scroll-loading"
                        >
                          <div class="d-flex justify-content-center align-items-center py-2" style="color: var(--kit-color-primary);">
                            <a-spin size="small" />
                            <span class="ml-2">{{ $t('promotion.loading_products') }}</span>
                          </div>
                        </a-select-option>
                      </a-select>
                    </template>
                    <template slot="original_price" slot-scope="text">
                      <div>{{ text }}</div>
                    </template>
                    <template slot="stock" slot-scope="text">
                      <div>{{ text }}</div>
                    </template>
                    <template slot="price_discount" slot-scope="text, record">
                      <a-form-item
                        :validate-status="record.validateStatus"
                        :help="record.callbackStatus"
                        class="mb-0"
                      >
                        <a-input
                          v-model="record.promotion_price_nominal"
                          :disabled="record?.sku === ''"
                          placeholder="..."
                          addon-before="Rp"
                          @change="handleChangePromotionPrice($event.target.value, record, 'nominal')"
                        />
                      </a-form-item>
                    </template>
                    <template slot="discount" slot-scope="text, record">
                      <a-input
                        v-model="record.promotion_price_percentage"
                        :disabled="record?.sku === ''"
                        placeholder="..."
                        addon-after="%"
                        @change="handleChangePromotionPrice($event.target.value, record, 'percentage')"
                      />
                    </template>
                    <template slot="stock_promosi" slot-scope="">
                      <a-input :default-value="$t('promotion.unlimited')" disabled />
                    </template>
                    <template slot="max_purchase" slot-scope="">
                      <a-input :default-value="$t('promotion.unlimited')" disabled />
                    </template>
                  </a-table>
                </div>
              </a-col>
            </a-row>
          </a-spin>
        </a-card>

        <div v-if="!isDetail" class="discount-footer">
          <a-button
            type="primary"
            size="large"
            class="mr-4"
            ghost
            :disabled="isLoading"
            @click="goBack"
          >
            {{ $t('utils.cancel') }}
          </a-button>
          <a-button
            type="primary"
            size="large"
            :loading="isLoading"
            @click="onSubmitCreatePromotion"
          >
            {{ $route.query.discount_id && !isDuplicate ? $t('promotion.confirm_edit') : $t('promotion.confirmation') }}
          </a-button>
        </div>
      </a-form-model>
    </a-spin>
    <ModalBulkItemImport
      :is-loading="isLoading"
      :visible="showModalBulkItemImport"
      :on-close="() => showModalBulkItemImport = false"
      @handleSubmitModal="onNormalizeData"
    />
    <ModalFeedbackAfterImport
      :revised-data="listRevisedBulkItemImport"
      :is-loading="isLoading"
      :visible="showModalFeedbackAfterImport"
      :on-close="() => showModalFeedbackAfterImport = false"
    />
    <ModalAddSupplier
      :is-loading="isLoading"
      :visible="showModalAddSupplier"
      :business-id="businessId"
      @onCancel="showModalAddSupplier = false"
    />
  </div>
</template>

<script>
import { columnsCreatePromoChannel } from '@/data/columns'
import { useInputNumber } from '@/composable/useInputNumber'
import { useDateTime } from '@/composable/useDateTime'
import TrashIcon from '@/components/Icons/TrashIcon.vue'
import debounce from 'lodash/debounce'
import ModalBulkItemImport from '@/views/products/promo-channel/modal/ModalBulkItemImport.vue'
import ModalFeedbackAfterImport from '@/views/products/promo-channel/modal/ModalFeedbackAfterImport.vue'
import { useCurrency } from '@/composable/useCurrency'
import ModalAddSupplier from '@/views/supplier/ModalAddSupplier.vue'
import {
  getShopeeProductChannelList,
  createShopeePromotionChannel,
  getShopeePromotionChannelDetail,
  updateShopeePromotionChannel,
  checkShopeeProductChannelEligibleForPromotion,
  getShopeeSyncProcessStatus,
  syncSingleShopeePromotionChannel,
} from '@/api/channels/shopee'
import { getAllocationStock } from '@/api/inventory'

export default {
  name: 'CreatePurchaseOrder',
  components: {
    TrashIcon,
    ModalBulkItemImport,
    ModalFeedbackAfterImport,
    ModalAddSupplier,
  },
  beforeRouteLeave(to, from, next) {
    next()
  },
  setup() {
    const { format, parseLocaleNumber } = useCurrency()
    const { numberOnly, toNumber } = useInputNumber()
    const { parseISODate } = useDateTime()
    return {
      format,
      parseLocaleNumber,
      numberOnly,
      toNumber,
      parseISODate,
    }
  },
  data() {
    return {
      defaultTier: 1,
      readyTier: 1,
      currTier: 1,
      currQuota: 0,
      sellerId: [],
      idPromo: -1,
      dateFormat: 'DD MMM YYYY, HH:mm',
      isLoading: false,
      isDetail: false,
      endOpen: false,
      visible: false,
      areaAll: false,
      distributorAll: false,
      categoryAll: false,
      customerAll: false,
      itemList: [],
      warehouseList: [],
      supplierList: [],
      loadingSupplierList: false,
      inventories: [],
      initVal: {},
      search: '',
      overlayStyle: {
        width: '100px',
      },
      params: {
        page: 1,
        size: 1000,
      },
      rulesCreatePromotion: {
        promoCode: [{
          required: true,
          trigger: 'blur',
          message: this.$t('promotion.promo_code_required'),
        }],
        startDate: [{
          required: true,
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(this.$t('promotion.start_date_required')))
            }
            if (this.rawStatusPromotion?.toLowerCase() !== 'ongoing' && value && !value.isSameOrAfter(this.$moment())) {
              callback(new Error(this.$t('promotion.start_date_after_now')))
            }
            if (this.rawStatusPromotion?.toLowerCase() === 'upcoming') {
              if (value && !value.isSameOrAfter(this.rawStartDatePromotion)) {
                callback(new Error(this.$t('promotion.start_date_after_prev', { date: this.$moment(this.rawStartDatePromotion).format('DD MMM YYYY, HH:mm') })))
              }
            }
            callback()
          },
        }],
        endDate: [{
          required: true,
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(this.$t('promotion.end_date_required')))
            }
            const currentStartDate = this.$moment(this.form.startDate)
            if (value && !value.isSameOrAfter(currentStartDate.add(1, 'minute'))) {
              callback(new Error(this.$t('promotion.end_date_after_start')))
            }
            if (value && !value.isSameOrAfter(currentStartDate.add(59, 'minute'))) {
              callback(new Error(this.$t('promotion.end_date_min_1hour')))
            }
            if (['upcoming', 'ongoing'].includes(this.rawStatusPromotion?.toLowerCase())) {
              if (value && value.isSameOrAfter(this.$moment(this.rawEndDatePromotion).add(1, 'minute'))) {
                callback(new Error(this.$t('promotion.end_date_before_prev', { date: this.$moment(this.rawEndDatePromotion).format('DD MMM YYYY, HH:mm') })))
              }
            }
            callback()
          },
        }],
        allDiscountNominal: [{
          required: false,
          trigger: 'change',
          validator: (rule, value, callback) => {
            let lowestPrice = 0
            if (this.itemList.length > 0) {
              lowestPrice = Math.min(...this.itemList.map(item => item.raw_price - 1 || 0))
            }
            if (value && this.form.allDiscountPercentage) {
              callback(new Error(this.$t('promotion.discount_exclusive')))
            } else if (value && this.itemList.length > 0 && Number(value) > lowestPrice) {
              callback(new Error(this.$t('promotion.discount_too_high', { price: lowestPrice })))
            } else {
              callback()
            }
          },
        }],
        allDiscountPercentage: [{
          required: false,
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (value && this.form.allDiscountNominal) {
              callback(new Error(this.$t('promotion.discount_exclusive')))
            } else {
              callback()
            }
          },
        }],
      },
      form: {
        promoCode: undefined,
        startDate: undefined,
        endDate: undefined,
        allDiscountNominal: undefined,
        allDiscountPercentage: undefined,
        // startDate: this.$moment().add(1, 'day'),
        // endDate: this.$moment().add(1, 'day').add(1, 'month'),
      },
      previousStartDate: null,
      previousEndDate: null,
      showModalBulkItemImport: false,
      listRevisedBulkItemImport: [],
      showModalFeedbackAfterImport: false,
      showModalAddSupplier: false,
      loadingFetchProductChannelList: false,
      productChannelList: [],
      loadingFetchPromotionChannelDetail: false,
      currentPage: 1,
      productChannelHasMoreData: true,
      totalProductChannel: 0,
      openStartDatePicker: false,
      openEndDatePicker: false,
      editItemList: [],
      rawStatusPromotion: '',
      rawStartDatePromotion: null,
      rawEndDatePromotion: null,
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '',
          dataIndex: 'action1',
          key: 'action1',
          width: 50,
          scopedSlots: {
            customRender: 'action1',
          },
        },
        {
          title: this.$t('promotion.columns.product_name'),
          dataIndex: 'catalog_id',
          key: 'catalog_id',
          width: 350,
          scopedSlots: {
            customRender: 'selected_catalog_id',
          },
        },
        {
          title: this.$t('promotion.columns.original_price'),
          dataIndex: 'original_price',
          key: 'original_price',
          scopedSlots: {
            customRender: 'original_price',
          },
        },
        {
          title: this.$t('promotion.columns.discount_price'),
          dataIndex: 'promotion_price_nominal',
          key: 'promotion_price_nominal',
          scopedSlots: {
            customRender: 'price_discount',
          },
        },
        {
          title: this.$t('promotion.columns.discount'),
          dataIndex: 'promotion_price_percentage',
          key: 'promotion_price_percentage',
          width: 150,
          scopedSlots: {
            customRender: 'discount',
          },
        },
        {
          title: this.$t('promotion.columns.promo_stock'),
          dataIndex: 'stock_promosi',
          key: 'stock_promosi',
          width: 200,
          scopedSlots: {
            customRender: 'stock_promosi',
          },
        },
        {
          title: this.$t('promotion.columns.purchase_limit'),
          dataIndex: 'max_purchase',
          key: 'max_purchase',
          width: 200,
          scopedSlots: {
            customRender: 'max_purchase',
          },
        },
      ]
    },
    customIndicatorMandatoryDateRange() {
      return (
        <div class="w-100" style="left: 0; margin: 0;">
          {(!this.form.startDate || !this.form.endDate) && (
            <a-alert
              class="w-50"
              style="margin-inline: auto;"
              message={this.$t('promotion.mandatory_date_range')}
              type="warning"
              show-icon
            />
          )}
        </div>
      )
    },
    disabledFormAppliedAllDiscount() {
      // return this.itemList.filter((item) => item.channel_product_id).length === 0;
      return false
    },
    disabledCheckBothDiscount() {
      return (this.form.allDiscountNominal && this.form.allDiscountPercentage) || (!this.form.allDiscountNominal && !this.form.allDiscountPercentage)
    },
    businessId() {
      return this.$store.state.user.restriction_base === 'Warehouse'
        ? Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
        : this.$route.query.business_id
    },
    business() {
      return Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
    },
    isPrinciple() {
      return ['business owner', 'supervisor', 'store operator', 'principle'].includes(this.$store.state.user.role_name?.toLowerCase())
    },
    selectedSKU() {
      return this.itemList.map((obj2) => obj2.sku)
    },
    computedValidSKU() {
      return this.itemList.filter((obj) => obj.catalog_id)?.length
    },
    isEdit() {
      return this.$route.params.promotionId
    },
  },
  watch: {
    businessId() {
    },
  },
  mounted() {
    if (this.isEdit) {
      this.handleSingleSyncPromotion()
      // this.actionSuccessSync()
    }
  },
  methods: {
    validateFieldDiscountPerItem(record, type) {
      if (type) {
        return {
          status: 'error',
          help: 'error',
        }
      }
      return {
        status: '',
        help: '',
      }
    },
    disabledDateBeforeCurrentDate(current) {
      return current && current < this.$moment().subtract(1, 'days').endOf('day');
    },
    disabledDateBeforeSelectedStartDate(current) {
      return current && current < this.$moment().subtract(1, 'days').endOf('day');
    },
    handleChangePromotionDate(e, type) {
      let fieldForm = type === 'mulai' ? 'startDate' : 'endDate'
      let fieldPrevious = type === 'mulai' ? 'previousStartDate' : 'previousEndDate'
      const isAlreadyAddProduct = this.itemList.some((item) => item.channel_product_id)
      
      let modifiedDate = e
      this.$refs.createPromotionForm.validateField('startDate')
      this.$refs.createPromotionForm.validateField('endDate')
      this.closeDatePicker()
      if (!this[fieldPrevious] || !isAlreadyAddProduct) {
        this[fieldPrevious] = modifiedDate
        return
      }
      this.$modal.confirm({
        title: this.$t('promotion.change_date_confirm', { type }),
        content: this.$t('promotion.change_date_desc'),
        okText: this.$t('promotion.yes_change_date', { type }),
        cancelText: this.$t('utils.no'),
        onOk: () => {
          this[fieldPrevious] = modifiedDate
          return
        },
        onCancel: () => {
          this.form[fieldForm] = this[fieldPrevious]
          return
        },
      })
    },
    closeDatePicker() {
      this.openStartDatePicker = false
      this.openEndDatePicker = false
    },
    handleFocusProductChannelList() {
      if (this.currentPage === 1 || !this.productChannelList.length) {
        this.fetchProductChanelList()
      }
    },
    getTipSpinningByState() {
      if (this.loadingFetchPromotionChannelDetail) {
        return this.$t('promotion.wait_fetching_detail')
      }
      if (this.isLoading) {
        if (this.isEdit) {
          return this.$t('promotion.wait_updating')
        } else {
          return this.$t('promotion.wait_creating')
        }
      }
      return ''
    },
    actionSuccessSync() {
      this.fetchPromotionChannelDetail()
    },
    actionFailedSync() {
      this.loadingFetchPromotionChannelDetail = false
      this.$modal.confirm({
        title: this.$t('utils.failed'),
        content: this.$t('promotion.failed_fetch_detail'),
        okText: this.$t('utils.reload'),
        cancelText: this.$t('utils.back'),
        iconType: 'close-circle',
        onCancel: () => {
          this.$router.back()
        },
        onOk: () => {
          this.handleSingleSyncPromotion()
        },
      })
    },
    async actionCheckProgressSync(request_id) {
      try {
        const { data } = await getShopeeSyncProcessStatus({
          business_id: this.$route.query.business_id,
          channel_id: this.$route.params.id,
          request_id,
        })
        if (data?.data?.toUpperCase() === 'ON_PROCESS') {
          setTimeout(() => {
            this.actionCheckProgressSync(request_id)
          }, 5000)
        } else if (data?.data?.toUpperCase() === 'COMPLETED') {
          this.actionSuccessSync()
        } else if (data?.data?.toUpperCase() === 'FAILED') {
          this.actionFailedSync()
        }
      } catch (error) {
        console.error('Error syncing promotion channel:', error)
        setTimeout(() => {
          this.actionCheckProgressSync(request_id)
        }, 5000)
      }
    },
    async handleSingleSyncPromotion() {
      try {
        this.loadingFetchPromotionChannelDetail = true
        const { data } = await syncSingleShopeePromotionChannel({
          channel_id: this.$route.params.id,
          promotion_id: this.$route.params.promotionId,
          business_id: this.$route.query.business_id,
        })
        if (data?.data?.sync_status?.toUpperCase() === 'ON_PROCESS') {
          setTimeout(() => {
            this.actionCheckProgressSync(data?.data?.request_id)
          }, 2000)
        } else if (data?.data?.sync_status?.toUpperCase() === 'COMPLETED') {
          this.actionSuccessSync()
        } else if (data?.data?.toUpperCase() === 'FAILED') {
          this.actionFailedSync()
        }
      } catch (error) {
        let errorMessages = this.$t('promotion.sync_failed')
        console.error('Error syncing promotion channel:', error)
        if (error.response?.data?.message) {
          errorMessages = error.response.data.message
        }
        this.$notification.destroy()
        this.$notification.error({
          message: errorMessages,
        })
      }
    },
    async fetchPromotionChannelDetail() {
      try { 
        const { data } = await getShopeePromotionChannelDetail({
          channel_id: this.$route.params.id,
          business_id: this.businessId,
          promotion_id: this.$route.params.promotionId,
        })
        if (data?.data?.promotion_id) {
          this.form = {
            promoCode: data?.data?.promotion_name,
            startDate: this.$moment.unix(data?.data?.start_time),
            endDate: this.$moment.unix(data?.data?.end_time),
          }
          this.rawStatusPromotion = data?.data?.status || ''
          this.rawStartDatePromotion = data?.data?.start_time ? this.$moment.unix(data?.data?.start_time) : null
          this.rawEndDatePromotion = data?.data?.end_time ? this.$moment.unix(data?.data?.end_time) : null
          if (data?.data?.item_list?.length > 0) {
            const listTitle = data.data.item_list.map((item) => {
              return {
                itemName: item.channel_product_name,
                itemChannelCatalogID: item.catalog_id,
                itemChannelProductID: item.product_id,
              }
            })
            const finalCurrentItemList = await this.fetchFindProductChanelListByTitle(listTitle)
            let currentIndex = this.itemList.length
            finalCurrentItemList.forEach((item) => {
              this.addItem()
              this.handleChangeProduct(`${item.channel_product_id}.${item.channel_catalog_id}`, this.itemList[currentIndex])
              const findItem = data.data.item_list.find((item2) => String(item2.product_id) === String(item.channel_product_id) && ((!item2.catalog_id && !item.channel_catalog_id) || (String(item2.catalog_id) === String(item.channel_catalog_id))))
              const promotionPrice = findItem?.item_promotion_price
              this.handleChangePromotionPrice(promotionPrice, this.itemList[currentIndex], 'nominal')
              currentIndex++
            })
          }
        }
      } catch (error) {
        console.error(error)
        this.$notification.error({
          message: this.$t('promotion.failed_fetch_detail'),
        })
      } finally {
        this.loadingFetchPromotionChannelDetail = false
      }
    },
    filterOption(input, option) {
      const itemTitle = option.componentOptions.children[0].text;
      const itemSKU = option.componentOptions.children[2].text;
      const keyword = input.toLowerCase();
        
      return (
        itemTitle.toLowerCase().indexOf(keyword) !== -1 ||
        itemSKU.toLowerCase().indexOf(keyword) !== -1
      )
    },
    onChangeInputCart(value, index, field) {
      const currentItemList = this.itemList[index]
      if (field === 'quantity' && value > 9999) {
        value = 9999
      }
      currentItemList[field] = value
      currentItemList.total_price = currentItemList.price * (currentItemList?.quantity || 0)
    },
    ellipsisText(text) {
      if(!text) return '-'
      return text.length > 29 ? `${text.substring(0, 26)}...` : text
    },
    onSubmitCreatePromotion() {
      this.$refs.createPromotionForm.validate(async (valid) => {
        if (valid) {
          if (this.itemList.filter(v => v.channel_product_id).length === 0) {
            this.$notification.destroy()
            return this.$notification.error({
              message: this.$t('promotion.sync_failed'),
              description: this.$t('promotion.failed_add_product_desc'),
            })
          }

          const checkItemList = this.itemList.map((item) => {
            let currentValidateStatus = item.validateStatus
            let currentCallbackStatus = item.callbackStatus
            if (!item.promotion_price_nominal || !item.promotion_price_percentage) {
              currentValidateStatus = 'error'
              currentCallbackStatus = this.$t('promotion.error_fill_discount')
            }
            const newDataObject = {
              ...item,
              validateStatus: currentValidateStatus,
              callbackStatus: currentCallbackStatus,
            }
            return newDataObject
          })

          if (checkItemList?.some(v => v.validateStatus === 'error')) {
            this.itemList = checkItemList
            return
          }
          // return this.$notification.error({
          //   message: 'masih gabolee',
          //   description: 'lagi ditest',
          // })
          this.isLoading = true
          const {
            promoCode,
            startDate, 
            endDate,
          } = this.form
          const payload = {
            discount_name: promoCode,
            start_time: startDate.unix(),
            end_time: endDate.unix(),
            item_list: this.itemList.map(v => {
              const data = {
                item_id: Number(v.channel_product_id),
                item_name: v.catalog_title,
                model_id: v.isMultiVariant ? Number(v.channel_catalog_id) : null,
                model_name: v.isMultiVariant ? v.model_title : null,
                item_promotion_price: v.promotion_price_nominal || 0,
                item_promotion_stock: null,
                channel_product_id: v.master_product_id,
                channel_catalog_id: v.master_catalog_id,
                purchase_limit: 0,
              }
              return data
            }),
          }
          if (this.isEdit) {
            await updateShopeePromotionChannel({
              channel_id: this.$route.params.id,
              business_id: this.businessId,
              promotion_id: this.$route.params.promotionId,
              data: payload,
            })
            .then(() => {
              this.isLoading = false
              this.$notification.success({
                message: this.$t('utils.success_save'),
              })
              this.goBack()
            })
            .catch((err) => {
              console.error({err})
              this.$notification.error({
                message: err?.response?.data?.message || this.$t('utils.failed_save'),
              })
              this.isLoading = false
            })
          } else {
            await createShopeePromotionChannel({
              channel_id: this.$route.params.id,
              business_id: this.businessId,
              data: payload,
            })
            .then(() => {
              this.isLoading = false
              this.$notification.success({
                message: this.$t('utils.success_save'),
              })
              this.goBack()
            })
            .catch((err) => {
              console.error({err})
              this.$notification.error({
                message: err?.response?.data?.message || this.$t('utils.failed_save'),
              })
              this.isLoading = false
            })
          }

        }
      })
    },
    handleSearch: debounce(function(e) {
      this.search = e
    }, 500),
    handleResetSearch() {
      this.search = ''
    },
    handleChangeAppliedAllDiscount() {
      let isError = false
      this.$refs.createPromotionForm.validate((valid, errorMessages) => {
        if (!errorMessages?.allDiscountNominal && !errorMessages?.allDiscountPercentage) {
          this.$notification.success({
            message: this.$t('promotion.apply_discount_success'),
          })
        } else {
          isError = true
        }
      })
      if (isError) {
        return
      }
      let typeAllDiscount = ''
      let valueAllDiscount = ''
      if (this.form.allDiscountNominal) {
        typeAllDiscount = 'nominal'
        valueAllDiscount = this.form.allDiscountNominal
      } else if (this.form.allDiscountPercentage) {
        typeAllDiscount = 'percentage'
        valueAllDiscount = this.form.allDiscountPercentage
      } else {
        typeAllDiscount = ''
      }
      if (typeAllDiscount === '') {
        this.$notification.error({
          message: this.$t('promotion.apply_discount_failed'),
        })
      }
      this.itemList.forEach(item => {
        this.handleChangePromotionPrice(valueAllDiscount, item, typeAllDiscount)
      })
    },
    handleChangePromotionPrice(price, record, type) {
      let value = String(price).replace(/[^0-9]/g, '');
      if (!value || !Number(value)) {
        record.promotion_price_percentage = 0
        record.promotion_price_nominal = 0
        record.validateStatus = 'error'
        record.callbackStatus = this.$t('promotion.error_fill_discount')
        return
      }
      let discountPrice = 0
      if (type === 'percentage') {
        if (Number(value) > 99) {
          value = 99
        }
        discountPrice = record.raw_price * (Number(value) / 100)
        record.promotion_price_percentage = Number(value)
        record.promotion_price_nominal = record.raw_price - discountPrice
        record.validateStatus = ''
        record.callbackStatus = ''
      } else {
        const lowestPrice = record.raw_price - 1
        if (Number(value) > lowestPrice) {
          record.validateStatus = 'error'
          record.callbackStatus = this.$t('promotion.discount_limit_error', { price: lowestPrice })
        } else {
          record.validateStatus = ''
          record.callbackStatus = ''
        }
        discountPrice = record.raw_price - Number(value)
        record.promotion_price_percentage = Math.ceil(discountPrice / record.raw_price * 100)
        record.promotion_price_nominal = Number(value)
      }
    },
    async handleChangeProduct(value, record, poolData) {
      const selectedPoolData = poolData && poolData?.length > 0 ? poolData : this.productChannelList
      const findSelectedProduct = selectedPoolData.find(item => {
        return String(item.channel_product_id) === value.split('.')[0] && String(item.channel_catalog_id) === value.split('.')[1]
      })
      record.selected_catalog_id = value
      record.channel_product_id = value.split('.')[0]
      record.channel_catalog_id = value.split('.')[1]
      record.master_catalog_id = findSelectedProduct?.master_catalog_id || null
      record.master_product_id = findSelectedProduct?.master_product_id || null
      record.catalog_title = findSelectedProduct?.isMultiVariant ? findSelectedProduct?.productTitle : findSelectedProduct?.title
      record.model_title = findSelectedProduct?.isMultiVariant ? findSelectedProduct?.catalogTitle : null
      record.sku = findSelectedProduct?.sku || ''
      record.raw_price = findSelectedProduct?.price[0]?.original_price || 0
      record.original_price = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(findSelectedProduct?.price[0]?.original_price || 0)
      record.stock = findSelectedProduct?.currentStock || 0
      record.stock_promosi = this.$t('promotion.unlimited')
      record.max_purchase = this.$t('promotion.unlimited')
      record.isMultiVariant = findSelectedProduct?.isMultiVariant || false
    },
    onDeleteItem(record) {
      const filter = this.itemList.filter(v => {return v.item_reference_id !== record.item_reference_id})
      const temp = filter.map((v, i) => {
        const data = {
          ...v,
          item_reference_id: typeof v.item_reference_id === 'string' ? v.item_reference_id : i + 1,
        }
        return data
      })
      this.itemList = temp
    },
    onNormalizeData(importedData) {
      this.isLoading = true
      this.listRevisedBulkItemImport = []
      const normalizeData = []
      importedData.map((obj) => {
        const status = []
        const newObj = Object.fromEntries(
          Object.entries(obj).map(([key, val]) => [key.replace(/\s/g, '').toLowerCase(), val]),
        );
        const isDuplicatedSKU = normalizeData.find((obj2) => obj2.sku === newObj.sku)
        if (isDuplicatedSKU) {
          status.push('duplicated_sku')
        }
        if (newObj?.hargapromosinominal && newObj?.hargapromosipersentase) {
          status.push('multiple_value_promotion')
        }
        if (!newObj?.hargapromosinominal && !newObj?.hargapromosipersentase) {
          status.push('empty_value_promotion')
        }
        if (newObj?.hargapromosinominal !== undefined) {
          const num = Number(newObj?.hargapromosinominal)
          if (!(!isNaN(num) && typeof num === 'number' && num > 0)) {
            status.push('price_not_valid')
          }
        }
        if (status.length) {
          this.listRevisedBulkItemImport.push({
            ...newObj,
            status: status,
          })
          return
        }
        normalizeData.push(newObj)
      })
      this.onSubmitBulkItemImport(normalizeData)
    },
    async onSubmitBulkItemImport(importedData) {
      const unlistItems = []
      const tempItemList = this.itemList
      importedData.map((obj) => {
        const isDuplicatedSKU = tempItemList.find((obj2) => obj2.sku === obj.sku)
        if (isDuplicatedSKU) {
          return
        }
        unlistItems.push(obj)
      })

      if (unlistItems.length) {
        const finalImportedItemList = await this.fetchFindProductChanelListBySKU(unlistItems.map((item) => item.sku))
        let currentIndex = this.itemList.length
        let countSuccess = 0
        let countFail = 0
        finalImportedItemList.forEach((item) => {
          if (!item.isEligible) {
            countFail++
            return
          }
          countSuccess++
          this.addItem()
          this.handleChangeProduct(`${item.channel_product_id}.${item.channel_catalog_id}`, this.itemList[currentIndex])
          const findItem = unlistItems.find((item2) => item2.sku === item.sku)
          const promotionPrice = findItem?.hargapromosinominal || findItem?.hargapromosipersentase
          const promotionType = findItem?.hargapromosinominal ? 'nominal' : 'percentage'
          this.handleChangePromotionPrice(promotionPrice, this.itemList[currentIndex], promotionType)
          currentIndex++
        })
        const notificationType = countFail === 0 ? 'success' : 'error';
        let notificationMessage = '';
        if (countFail === 0 && countSuccess > 0) {
          notificationMessage = this.$t('promotion.import_success_all', { count: countSuccess });
        } else if (countFail > 0 && countSuccess > 0) {
          notificationMessage = this.$t('promotion.import_success_partial', { fail: countFail, success: countSuccess });
        } else if (countSuccess === 0) {
          notificationMessage = this.$t('promotion.import_failed_all');
        }
        this.$notification[notificationType]({
          message: notificationMessage,
        });
      }
      this.isLoading = false
      this.showModalBulkItemImport = false
    },
    onChangeQuantity(event, record) {
      record.base_quantity = +event * +record.units[record.uom].numerator
    },
    addItem() {
      const arr = this.itemList
      const temp = {
          item_reference_id: arr.length + 1,
          selected_catalog_id: null,
          catalog_id: '',
          catalog_title: '',
          quantity: '',
          uom: '',
          sku: '',
          batch_number: '',
          expired_date: null,
          stock_type: 'AV',
          base_quantity: '',
          base_uom: '',
          serial_number: '',
          levels: [],
          units: {},
          price: null,
          total_price: 0,
          original_price: '',
          stock: '',
          stock_promosi: '',
          max_purchase: '',
          promotion_price_nominal: null,
          promotion_price_percentage: null,
      }
      arr.push(temp)
      this.itemList = arr
    },
    goBack() {
      this.$router.back({
        path: '/inventory/goods-receipt',
        query: { ...this.$route.query },
      })
    },
    async fetchFindProductChanelListBySKU(arrSKU) {
      try {
        this.loadingFetchProductChannelList = true
        const promises = []
        const importedSKU = []
        arrSKU.forEach((sku) => {
          importedSKU.push(sku)
          promises.push(
            getShopeeProductChannelList({
              business_id: this.businessId,
              channel_id: this.$route.params.id,
              params: {
                workspace_id: this.$route.query.workspace_id,
                page: 1,
                limit: 10,
                status: 'CONFIRMED',
                q: sku,
              },
            }),
          )
        })
        const resProductChannelList = await Promise.all(promises)
        const validListProductChannel = []
        resProductChannelList.forEach((item, index) => {
          if (item?.data?.total_row === 1) {
            validListProductChannel.push(item.data.data[0])
          } else if (item?.data?.total_row > 1) {
            let findSpecificCatalog = null
            item.data.data.forEach((obj) => {
              if (obj?.catalogs?.length > 0) {
                const findSKU = obj?.catalogs?.find((cat) => cat?.sku === arrSKU[index])
                if (findSKU) {
                  findSpecificCatalog = findSKU
                }
              }
            })
            if (findSpecificCatalog) {
              validListProductChannel.push(findSpecificCatalog)
            }
          } else {
            console.error('invalid sku', arrSKU[index])
          }
        })
        this.loadingFetchProductChannelList = true
        const uniqueProductIds = [...new Set(validListProductChannel.map(item => item.product_id))];
        const distinctValidListProductChannel = uniqueProductIds.map(productId => {
          return validListProductChannel.find(item => item.product_id === productId);
        });

        if (distinctValidListProductChannel.length > 0 ) {
          let checkingListProductChannel = []
          let checkingListInventory = []
          distinctValidListProductChannel.forEach((item) => {
            const currentListProductChannel = item?.catalogs?.map((obj) => {
              checkingListInventory.push(obj.master_catalog_id)
              return {
                item_id: String(obj.channel_product_id),
                model_id: obj.channel_catalog_id !== 0 ? String(obj.channel_catalog_id) : null,
              }
            })
            checkingListProductChannel = [ ...checkingListProductChannel, ...currentListProductChannel ]
          })
          const [eligibleResponse, allocationResponse] = await Promise.all([
            checkShopeeProductChannelEligibleForPromotion({
              business_id: this.businessId,
              channel_id: this.$route.params.id,
              params: {
                start_time: this.form.startDate.unix(),
                end_time: this.form.endDate.unix(),
              },
              data: checkingListProductChannel,
            }),
            getAllocationStock({
              business_id: this.businessId,
              channel_id: this.$route.params.id, 
              catalog_id: checkingListInventory.join(','),
            }),
          ]);
          const { data: listEligibleProductIds } = eligibleResponse;
          const { data: listAllocationStock } = allocationResponse;
          let newData = []
          distinctValidListProductChannel.forEach((item) => {
            item.catalogs?.forEach((itemCatalog) => {
              if (importedSKU.includes(itemCatalog.sku)) {
                const isMultiVariant = item.catalogs?.length > 1
                const key = isMultiVariant ? `${itemCatalog.channel_product_id}==${itemCatalog.channel_catalog_id}` : String(itemCatalog.channel_product_id)
                const isEligible = listEligibleProductIds.data.item_ids.includes(key)
                const filteredListStock = listAllocationStock?.filter((stock) => stock.catalog_id === itemCatalog.master_catalog_id)
                const countStock = filteredListStock?.reduce((acc, cur) => acc + cur.availability, 0)
                
                newData.push({
                  ...itemCatalog,
                  isEligible,
                  productTitle: item.title,
                  catalogTitle: itemCatalog.title.replace(item.title, '').trim(),
                  isMultiVariant: isMultiVariant,
                  currentStock: countStock,
                })
              }
            })
          })
          this.productChannelList = [...this.productChannelList, ...newData]
          return newData
        }
      } catch (error) {
        console.error(error)
        return error
      } finally {
      }
    },
    async fetchFindProductChanelListByTitle(arrData) {
      try {
        this.loadingFetchProductChannelList = true
        const promises = []
        const importedItemByChannelProductAndCatalogID = []
        arrData.forEach((item) => {
          importedItemByChannelProductAndCatalogID.push(item.itemChannelCatalogID ? `${item.itemChannelProductID}==${item.itemChannelCatalogID}` : `${item.itemChannelProductID}`)
          promises.push(
            getShopeeProductChannelList({
              business_id: this.businessId,
              channel_id: this.$route.params.id,
              params: {
                workspace_id: this.$route.query.workspace_id,
                page: 1,
                limit: 10,
                status: 'CONFIRMED',
                q: item.itemName,
              },
            }),
          )
        })
        const resProductChannelList = await Promise.all(promises)
        const validListProductChannel = []
        resProductChannelList.forEach((item, index) => {
          if (item?.data?.total_row === 1) {
            validListProductChannel.push(item.data.data[0])
          } else if (item?.data?.total_row > 1) {
            let findSpecificCatalog = null
            item.data.data.forEach((obj) => {
              if (obj?.catalogs?.length > 0) {
                const { itemName, itemChannelCatalogID, itemChannelProductID } = arrData[index]
                if (itemChannelCatalogID) {
                  const findSKU = obj?.catalogs?.find((cat) => String(cat?.channel_catalog_id) === String(itemChannelCatalogID) && String(cat?.channel_product_id) === String(itemChannelProductID))
                  if (findSKU) {
                    findSpecificCatalog = findSKU
                  }
                } else {
                  if (String(obj.channel_product_id) === String(itemChannelProductID)) {
                    findSpecificCatalog = obj
                  }
                }
              }
            })
            if (findSpecificCatalog) {
              validListProductChannel.push(findSpecificCatalog)
            }
          } else {
            console.error('invalid product name and catalog id', arrData[index])
          }
        })
        this.loadingFetchProductChannelList = true
        const uniqueProductIds = [...new Set(validListProductChannel.map(item => item.product_id))];
        const distinctValidListProductChannel = uniqueProductIds.map(productId => {
          return validListProductChannel.find(item => item.product_id === productId);
        });
        if (distinctValidListProductChannel.length > 0 ) {
          let checkingListProductChannel = []
          let checkingListInventory = []
          distinctValidListProductChannel.forEach((item) => {
            const currentListProductChannel = item?.catalogs?.map((obj) => {
              checkingListInventory.push(obj.master_catalog_id)
              return {
                item_id: String(obj.channel_product_id),
                model_id: obj.channel_catalog_id !== 0 ? String(obj.channel_catalog_id) : null,
              }
            })
            checkingListProductChannel = [ ...checkingListProductChannel, ...currentListProductChannel ]
          })
          this.editItemList = checkingListProductChannel.map((item) => item.model_id ? `${item.item_id}==${item.model_id}` : `${item.item_id}`)
          const [eligibleResponse, allocationResponse] = await Promise.all([
            checkShopeeProductChannelEligibleForPromotion({
              business_id: this.businessId,
              channel_id: this.$route.params.id,
              params: {
                start_time: this.form.startDate.unix(),
                end_time: this.form.endDate.unix(),
              },
              data: checkingListProductChannel,
            }),
            getAllocationStock({
              business_id: this.businessId,
              channel_id: this.$route.params.id, 
              catalog_id: checkingListInventory.join(','),
            }),
          ]);
          const { data: listAllocationStock } = allocationResponse;
          let newData = []
          distinctValidListProductChannel.forEach((item) => {
            item.catalogs?.forEach((itemCatalog) => {
              if (importedItemByChannelProductAndCatalogID.includes(itemCatalog.channel_catalog_id ? `${itemCatalog.channel_product_id}==${itemCatalog.channel_catalog_id}` : `${itemCatalog.channel_product_id}`)) {
                const isMultiVariant = item.catalogs?.length > 1
                const isEligible = true
                const filteredListStock = listAllocationStock?.filter((stock) => stock.catalog_id === itemCatalog.master_catalog_id)
                const countStock = filteredListStock?.reduce((acc, cur) => acc + cur.availability, 0)
                
                newData.push({
                  ...itemCatalog,
                  isEligible,
                  productTitle: item.title,
                  catalogTitle: itemCatalog.title.replace(item.title, '').trim(),
                  isMultiVariant: isMultiVariant,
                  currentStock: countStock,
                })
              }
            })
          })
          this.productChannelList = [...this.productChannelList, ...newData]
          return newData
        }
      } catch (error) {
        console.error(error)
        return error
      } finally {
      }
    },
    async fetchProductChanelList() {
      try {
        this.loadingFetchProductChannelList = true
        const { data } = await getShopeeProductChannelList({
          business_id: this.businessId,
          channel_id: this.$route.params.id,
          params: {
            workspace_id: this.$route.query.workspace_id,
            page: this.currentPage || 1,
            limit: 10,
            status: 'CONFIRMED',
          },
        })
        if (data?.data?.length > 0 ) {
          let checkingListProductChannel = []
          let checkingListInventory = []
          data.data.forEach((item) => {
            const currentListProductChannel = item?.catalogs?.map((obj) => {
              checkingListInventory.push(obj.master_catalog_id)
              return {
                item_id: String(obj.channel_product_id),
                model_id: obj.channel_catalog_id !== 0 ? String(obj.channel_catalog_id) : null,
              }
            })
            checkingListProductChannel = [ ...checkingListProductChannel, ...currentListProductChannel ]
          })
          const [eligibleResponse, allocationResponse] = await Promise.all([
            checkShopeeProductChannelEligibleForPromotion({
              business_id: this.businessId,
              channel_id: this.$route.params.id,
              params: {
                start_time: this.form.startDate.unix(),
                end_time: this.form.endDate.unix(),
              },
              data: checkingListProductChannel,
            }),
            getAllocationStock({
              business_id: this.businessId,
              channel_id: this.$route.params.id, 
              catalog_id: checkingListInventory.join(','),
            }),
          ]);
          const { data: listEligibleProductIds } = eligibleResponse;
          const { data: listAllocationStock } = allocationResponse;
          let newData = []
          data.data.forEach((item) => {
            if (item.catalogs?.length > 1) {
              const newMultiVariantList = item.catalogs.map((obj) => {
                let isEligible = this.editItemList.includes(`${obj.channel_product_id}==${obj.channel_catalog_id}`)
                if (!isEligible) {
                  isEligible = listEligibleProductIds.data.item_ids.includes(`${obj.channel_product_id}==${obj.channel_catalog_id}`)
                }
                const filteredListStock = listAllocationStock?.filter((stock) => stock.catalog_id === obj.master_catalog_id)
                const countStock = filteredListStock?.reduce((acc, cur) => acc + cur.availability, 0)
                return {
                  ...obj,
                  isEligible,
                  productTitle: item.title,
                  catalogTitle: obj.title.replace(item.title, '').trim(),
                  isMultiVariant: true,
                  currentStock: countStock,
                }
              })
              newData = [...newData, ...newMultiVariantList]
            } else {
              let isEligible = this.editItemList.includes(String(item?.catalogs[0]?.channel_product_id))
              if (!isEligible) {
                isEligible = listEligibleProductIds.data.item_ids.includes(String(item?.catalogs[0]?.channel_product_id))
              }
              const filteredListStock = listAllocationStock?.filter((stock) => stock.catalog_id === item?.catalogs[0]?.master_catalog_id)
              const countStock = filteredListStock?.reduce((acc, cur) => acc + cur.availability, 0)
              newData.push({
                ...item?.catalogs[0],
                isEligible,
                currentStock: countStock,
              })
            }
          })
          if (!this.currentPage || this.currentPage === 1) {
            this.productChannelList = newData
          } else {
            this.productChannelList = [...this.productChannelList, ...newData]
          }
          this.totalProductChannel = data.total_row
          this.productChannelHasMoreData = this.productChannelList.length < this.totalProductChannel
          this.currentPage = (this.currentPage || 1) + 1
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingFetchProductChannelList = false
      }
    },
    handleScrollProductChannelList({ target }) {
      const { scrollTop, scrollHeight, clientHeight } = target
      const isNearBottom = scrollHeight - scrollTop <= clientHeight + 50
      
      if (isNearBottom && !this.loadingFetchProductChannelList && this.productChannelHasMoreData) {
        this.fetchProductChanelList()
      }
    },
    validateNumberInput(e, field) {
      let value = e.target.value.replace(/[^0-9]/g, '');
      if (field === 'allDiscountPercentage') {
        if (value > 99) {
          value = '99';
        }
      }
      if (value === '') {
        value = undefined
      }
      this.$refs.createPromotionForm.validateField('allDiscountPercentage')
      this.$refs.createPromotionForm.validateField('allDiscountNominal')
      this.form[field] = value;
    },
  },
}
</script>

<style lang="scss">
@import './create.module.scss';
</style>
<style lang="scss" scoped>
.ant-select-lg .ant-select-selection--single .product-select {
  white-space: nowrap !important;
}
.product-select {
  white-space: pre-wrap !important;
  .sku-desc {
    font-size: 12px;
    font-weight: 500;
  }
}
</style>
